const $ = require('jquery')
const Promise = require('bluebird')
const errorBlock = require('templates/error-block.hbs')
const toastr = require('toastr')
const bus = require('sci/std/bus')

const nameIt = (formName, fieldName) => [formName, fieldName].filter(_ => !!_).join('.')

class ValidationError extends Error {
    constructor (data, statusCode, statusText) {
        super('Ocorreu um erro na validação')
        this.data = data
        this.statusCode = statusCode
        this.statusText = statusText
        this.skip = true
    }
}

module.exports = (form, onlyData = true, withGlobal = true) => (body) => new Promise((resolve, reject) => {
    const $form = $(form)

    const { errors, messages, data, vars, status_code, status_text, request_id } = body

    if (typeof console !== 'undefined' && vars && (console.group || console.groupCollapsed)) {
        if (typeof console.groupCollapsed !== 'undefined') {
            console.log('Last request vars');
            console.groupCollapsed()
        } else if(typeof console.group !== 'undefined') {
            console.log('Last request vars');
            console.group();
        }

        if (vars.hasOwnProperty('exClass')) {
            console.error(vars.exClass)
        }

        if (vars.hasOwnProperty('exception')) {
            console.error(vars.exception)
        }

        if (vars.hasOwnProperty('ex')) {
            console.error(vars.ex)
        }
        console.log(vars)
        console.groupEnd()
    }
    const formName = $form.attr('name') || $form.attr('data-name') || $form.attr('id')

    const namedErrors = errors.reduce((all, e) => {
        const key = e.field
        if (!all.hasOwnProperty(key)) {
            all[key] = []
        }

        return {
            ...all,
            [key]: all[key].concat([e])
        }
    }, {})

    bus.putErrors(formName, namedErrors)

    $form
        .find('.error-bag')
        .remove()

    $form
        .find('.form-group')
        .removeClass('has-validation-errors')
        .removeClass('alert')
        .removeClass('alert-warning')

    $form.find('.nav > li.has-validation-errors')
        .removeClass('has-validation-errors')

    const $inputs = []
    const $formInputs = $form.find('[data-field]')

    errors.forEach(function (item) {
        if (item.field === 'global' && withGlobal) {
            if (request_id) {
                toastr.error(item.message, `Protocolo: ${request_id}`)
            } else {
                toastr.error(item.message)
            }
            return
        }
        const $input = $form
            .find(`[data-field="${nameIt(formName, item.field)}"], [name="${nameIt(formName, item.field)}"]`)

        const loud = $input.hasClass('loud-error')

        const $group = $input.closest('.form-group')

        const $tabPane = $group.closest('.tab-pane')

        let $tab = null

        if ($tabPane.length) {
            const paneName = $tabPane.data('tab')

            if (paneName) {
                const $tabItem = $tabPane.parents('.tab-content')
                    .siblings('.nav')
                    .find(`.tab-${paneName}`)

                if ($tabItem.length) {
                    $tabItem.addClass('has-validation-errors')

                    $tab = $tabItem
                }
            }
        }

        $inputs.push({
            position: $formInputs.index($input),
            el: $input,
            tab: $tab,
            group: $group
        })

        if ($group.find('.messages-holder').length) {
            $group
                .addClass('has-validation-errors')
                .find('.messages-holder')
                .append(errorBlock({ ...item, loud }))
        } else {
            $group
                .addClass('has-validation-errors')
                .append(errorBlock({ ...item, loud }))
        }

        if (loud) {
            $group.addClass('alert alert-warning')
        }
    })

    messages.forEach(function (item) {
        if (item.field === 'global' && withGlobal) {
            toastr.info(item.message)
        }
    })

    const $focusOn = $inputs.sort((a, b) => {
        return a.position > b.position
    })[0]

    if ($focusOn) {
        if (!$focusOn.tab) {
            if ($focusOn.el.attr('type') === 'hidden') {
                setTimeout(() => {
                    $.scrollTo($focusOn.group, {
                        offset: -75,
                        animate: true
                    })
                }, 200)
            } else {
                $focusOn.el.focus()
            }
        } else {
            $focusOn.tab.click()
            $focusOn.tab.find('a').click()

            setTimeout(() => $focusOn.el.focus(), 5)
        }
    }

    if (errors.length) {
        return reject(new ValidationError(onlyData ? data : body, status_code, status_text), data)
    }

    return resolve(onlyData ? data : body)
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/vue-chaos.js